export function isGookiEnv() {
  return typeof webConfig !== 'undefined' && !!webConfig.api && webConfig.api.env === 'gooki';
}
